<div
  class="modal-header bg-head py-2 d-flex justify-content-between align-items-center"
>
  <h6 class="modal-title mb-0">Select Study Units for Practice Test</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>

<div class="row">
  <div class="col-12 headersize py-2">
    <span class="px-4 my-2 path-class">{{ path }}</span>
  </div>
</div>

<hr class="mt-0" />

<div class="modal-body m-body pt-0 px-0 scroll-area" cdkScrollable #scrollArea>
  <div class="p-4">
    <div *ngFor="let group of groupedStudyUnits" class="mb-4">
      <h6 class="fw-bold mb-2">
        {{ group.majorTopicName }}
      </h6>

      <table class="table table-fixed">
        <thead>
          <tr>
            <th class="text-center" style="width: 8%">Select</th>
            <th class="text-center" style="width: 46%">Topic</th>
            <th class="text-center" style="width: 46%">Study Unit Name</th>
          </tr>
        </thead>

        <tbody class="example-list">
          <tr
            *ngFor="let item of group.items; let i = index"
            [formGroup]="$any(group.formArray.at(i))"
            class="example-box"
          >
            <td>
              <div class="custom-input text-center">
                <input
                  type="checkbox"
                  formControlName="selected"
                  class="form-check-input"
                />
              </div>
            </td>

            <td>
              <div
                class="custom-input-path text-start"
                [title]="item.Path_Name"
              >
                {{ item.Path_Name }}
              </div>
            </td>

            <td>
              <div
                class="custom-input text-start"
                [title]="item.Study_Unit_Name"
              >
                {{ item.Study_Unit_Name }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer d-flex justify-content-end gap-2">
  <button type="button" class="bl-btn btn btn-sm px-3" (click)="onSave()">
    Select Questions
  </button>
</div>
